import styled from "styled-components";
import { colors } from "../../consts";

export const TableItemsCounterWrapper = styled.span`
  display: inline-flex;
  align-items: center;

  border-width: 1px;
  border-radius: 70px;
  background: rgba(93, 89, 100, 0.1);

  margin-left: 8px;
  padding: 2px 6px 2px 12px;

  & span {
    position: relative;

    color: ${colors.RAISIN_80};
    font-size: 12px;
    font-weight: 600;
    line-height: 120%;

    &:before {
      content: "+";

      position: absolute;
      top: -1px;
      left: -8px;
    }
  }
`;
